import SearchAutoComplete from './SearchAutoComplete'

export default SearchAutoComplete
// eslint-disable-next-line import/export
export * from './SearchAutoComplete'
